export default __webpack_public_path__ + "static/media/shield.f390ef5d.svg";